import { createAction } from 'redux-actions'
import { createApiActions } from '@tabeeb/shared/utils/actions'

export const openAiReportDialog = createAction('OPEN_AI_REPORT_DIALOG')
export const closeAiReportDialog = createAction('CLOSE_AI_REPORT_DIALOG')

export const selectAiObject = createAction('SELECT_AI_OBJECT')
export const selectTemplate = createAction('SELECT_TEMPLATE')

export const getAiObjectsByContent = createApiActions('GET_AI_OBJECTS_BY_CONTENT')
export const getAiObjectAnalysis = createApiActions('GET_AI_OBJECT_ANALYSIS')

export const goToAnnotation = createAction('GO_TO_ANNOTATION')

export const getPublishTemplates = createApiActions('GET_PUBLISH_TEMPLATES')
export const createPublishTemplate = createApiActions('CREATE_PUBLISH_TEMPLATE')
export const updatePublishTemplate = createApiActions('UPDATE_PUBLISH_TEMPLATE')
export const deletePublishTemplate = createApiActions('DELETE_PUBLISH_TEMPLATE')

export const publishAiReport = createApiActions('PUBLISH_AI_REPORT')

export const setAiReportNeedToRefresh = createAction('SET_AI_REPORT_NEED_TO_REFRESH')

export const openAiReportPublishSettingsDialog = createAction('OPEN_AI_REPORT_PUBLISH_SETTINGS_DIALOG')
export const closeAiReportPublishSettingsDialog = createAction('CLOSE_AI_REPORT_PUBLISH_SETTINGS_DIALOG')

export const getDefaultPublishName = createApiActions('GET_DEFAULT_PUBLISH_NAME')

export const updateUniqueAiObjectFromJson = createApiActions('UPDATE_UNIQUE_AI_OBJECT_FROM_JSON')
